import BaseService from "./BaseService";
import {ROOT, HISTORY} from "./_base";

class HistoryService extends BaseService {
    async getListPaymentTransaction(currentPage, params = {}) {
        const response = await this.get(`${ROOT}/${HISTORY}/get-list-payment-transaction?index=${currentPage}`, params);
        return response.data;
    }

    async submitExportCondition(params = {}) {
        const response = await this.get(`${ROOT}/${HISTORY}/submit-export-condition`, params);
        return response;
    }

    async getLoginHistory(params = {}) {
        return await this.get(`${ROOT}/${HISTORY}/login-history`, params);
    }
}

export default HistoryService;











